import React from 'react';
import { Empty } from 'antd';
import styles from './EmptyBlock.module.scss';
import { CardButton } from '../../../../Card';

const EmptyBlock = ({ onClick }) => {
  return (
    <>
      <Empty className={styles.empty} image={Empty.PRESENTED_IMAGE_SIMPLE} />
      {typeof onClick === 'function' && (
        <CardButton
          onClick={onClick}
          className={styles.button}
          text="Добавить подрядчика"
        />
      )}
    </>
  );
};

export default EmptyBlock;
